import {
  LayoutDashboard,
  User,
  CreditCard,
  Truck,
  Settings,
  Ambulance,
  RotateCcw,
  Shield,
  Megaphone,
  Bot,
} from "lucide-react";
import { getUploadsUrl } from "@/lib/serverConfig";
import DashboardShell, { DashboardMenuItem } from "@/components/dashboard/DashboardShell";

interface AmbulanceLayoutProps {
  children: React.ReactNode;
  provider?: {
    id: string;
    provider_name: string;
    provider_type?: string;
    kyc_status?: string;
    is_verified?: boolean;
    subscription_plan?: string;
    photo_url?: string;
  } | null;
  onLogout?: () => void;
}

const menuItems: DashboardMenuItem[] = [
  { icon: LayoutDashboard, label: "Dashboard", path: "/ambulance-provider/dashboard" },
  { icon: User, label: "My Profile", path: "/ambulance-provider/profile" },
  { icon: Truck, label: "My Vehicles", path: "/ambulance-provider/vehicles" },
  { icon: RotateCcw, label: "Return Trips", path: "/ambulance-provider/return-trips" },
  { icon: Shield, label: "KYC Status", path: "/ambulance-provider/kyc" },
  { icon: CreditCard, label: "Subscription", path: "/ambulance-provider/subscription" },
  { icon: Megaphone, label: "Book Ads", path: "/ambulance-provider/advertise" },
  { icon: Bot, label: "AI Profile", path: "/ambulance-provider/ai-profile" },
  { icon: Settings, label: "Settings", path: "/ambulance-provider/settings" },
];

const AmbulanceLayout = ({ children, provider, onLogout }: AmbulanceLayoutProps) => {
  const displayName =
    provider?.provider_name ||
    (provider as any)?.business_name ||
    (provider as any)?.contact_person ||
    "Ambulance Provider";
  // Was missing getUploadsUrl() resolution (unlike HomeCareLayout's equivalent),
  // so a relative-path photo_url silently rendered a broken avatar image.
  const rawPhotoUrl = provider?.photo_url || "";
  const photoUrl = rawPhotoUrl.startsWith('http') ? rawPhotoUrl : rawPhotoUrl ? getUploadsUrl(rawPhotoUrl) : "";

  return (
    <DashboardShell
      accent="ambulance"
      menuItems={menuItems}
      headerIcon={Ambulance}
      headerTitle="Ambulance Dashboard"
      displayName={displayName}
      subtitle={provider?.provider_type || "Provider"}
      photoUrl={photoUrl}
      kycStatus={provider?.kyc_status as "approved" | "pending" | "rejected" | undefined}
      isVerified={provider?.is_verified}
      subscriptionPlan={provider?.subscription_plan}
      dashboardType="ambulance"
      entityId={provider?.id || ''}
      notificationsPath="/ambulance-provider/notifications"
      profilePath="/ambulance-provider/profile"
      settingsPath="/ambulance-provider/settings"
      onLogout={() => onLogout?.()}
    >
      {children}
    </DashboardShell>
  );
};

export default AmbulanceLayout;